app-button{left:.6rem!important;bottom:auto!important}
/*# sourceMappingURL=pdf-download-button.component-DA3DNCC3.css.map */
